import React from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';
import Header from '../../General/components/Header';
import WelcomeHeading from './WelcomeHeading'
import AboutMe from './AboutMe'
import Footer from '../../General/components/Footer'

class HomePage extends React.Component {

	constructor (props) {
		super(props)
		this.state = {language: props.language}
		this.setLanguage = props.setLanguage
		this.navigateTo = props.navigateTo
		this.showPopup = props.showPopup
	}

	componentWillReceiveProps (props) {
		this.setState({language: props.language})
	}

	render () {
	  return (
	  	<ParallaxProvider>
	    <Header setLanguage={this.setLanguage} language={this.state.language} showPopup={this.showPopup} navigateTo={this.navigateTo}></Header>
	    <WelcomeHeading language={this.state.language}></WelcomeHeading>
	    <AboutMe language={this.state.language} showPopup={this.showPopup}></AboutMe>
	    <Footer language={this.state.language} setLanguage={this.setLanguage} showPopup={this.showPopup}></Footer>
  		</ParallaxProvider>
	  );
	}

}

export default HomePage;
